import languageEncoding from 'detect-file-encoding-and-language';

/** Use the CSV uploader's existing Windows-1252 fallback when detection is inconclusive. */
export async function detectCsvEncoding(file: File): Promise<string> {
  return (await languageEncoding(file)).encoding || 'CP1252';
}
